import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link'
import { Divider } from '@mui/material';
import { Trans, withTranslation, useTranslation  } from 'react-i18next';

interface apply_stat {
    apply_stat: string
  }

function QuestionProContent ({ apply_stat }: apply_stat) {
    const { t } = useTranslation();
    return ( 
        <Box>
            { apply_stat === "yes" ?
                <Box>
                <Typography sx={{ pt: 5, fontWeight: 400 }} variant='subtitle1'>
                    <Trans i18nKey="questionPro.applied_header" components={{
                        s: <strong />
                    }}></Trans>
            </Typography>
                    <Typography variant='subtitle1' sx={{mt: 5}}>
                        <Trans i18nKey="questionPro.goto">
                        <Link href='https://umac.questionpro.com.au' target='_blank' rel="noreferrer" />
                        </Trans>
                    </Typography>
                    <Divider sx={{ mt: 3, mb: 2}}></Divider>
                    <Typography>
                        <Trans i18nKey="questionPro.moreinfo">
                            <Link href="https://um-mo.libguides.com/questionpro/home" target="_blank" rel="noreferrer" /></Trans>
                    </Typography>
                </Box> : null
            }
            {   apply_stat === "no" ?
                <Box>
                <Typography sx={{ pt: 5, fontWeight: 400 }} variant='subtitle1'>
                <Trans i18nKey="questionPro.header" components={{
                    s: <strong />
                }}></Trans>
            </Typography>
                    <Divider sx={{ mt: 3}}></Divider>
                    <Typography variant='subtitle1' sx={{ mt: 2, fontWeight: 'bold', fontSize: 'h5.fontSize'}}>
                        {t("questionPro.terms_and_conditions")}
                    </Typography>
                    <Typography variant='subtitle1' sx={{ mt: 2, fontWeight: 'bold'}}>
                        {t("questionPro.terms_read")}
                    </Typography>
                    <Typography variant='subtitle1' component='ol' sx={{mt: 2}}>
                        <Trans i18nKey="questionPro.agreement" components={{
                            s: <Box component="span" sx={{ fontWeight: 500, color: 'red' }} />,
                            dot: <li />,
                            link1: <Link href='https://www.dspdp.gov.mo/file/Laws%20and%20Regulations/%E5%80%8B%E4%BA%BA%E8%B3%87%E6%96%99%E4%BF%9D%E8%AD%B7%E6%B3%95_EN.pdf' target='_blank' rel="noreferrer" />
                        }}></Trans>
                    </Typography>                   
                </Box>: null
            }
        </Box>
    );
};
export default withTranslation()(QuestionProContent);